import React from "react";
import { GlobalLabels } from "./globalLabels";

// Project Tab Enum using Global Labels
export const ProjectTabEnum = {
  DIVISIONS: {
    label: GlobalLabels.TABS.DIVISIONS.LABEL,
    icon: React.createElement(GlobalLabels.TABS.DIVISIONS.ICON),
  },
  CONTRACT: {
    label: GlobalLabels.TABS.CONTRACT.LABEL,
    icon: React.createElement(GlobalLabels.TABS.CONTRACT.ICON),
  },
  SUMMARY: {
    label: GlobalLabels.TABS.SUMMARY.LABEL,
    icon: React.createElement(GlobalLabels.TABS.SUMMARY.ICON),
  },
  ALLOCATIONS: {
    singular: GlobalLabels.TABS.ALLOCATIONS.SINGULAR,
    singularLower: GlobalLabels.TABS.ALLOCATIONS.SINGULAR.toLowerCase(),
    label: GlobalLabels.TABS.ALLOCATIONS.LABEL,
    labelLower: GlobalLabels.TABS.ALLOCATIONS.LABEL.toLowerCase(),
    icon: React.createElement(GlobalLabels.TABS.ALLOCATIONS.ICON),
    button: {
      label: GlobalLabels.TABS.ALLOCATIONS.BUTTON.LABEL,
      icon: React.createElement(GlobalLabels.TABS.ALLOCATIONS.BUTTON.ICON),
    },
    description: GlobalLabels.TABS.ALLOCATIONS.DESCRIPTION,
  },
  LOGS: {
    label: GlobalLabels.TABS.LOGS.LABEL,
    icon: React.createElement(GlobalLabels.TABS.LOGS.ICON),
  },
  INCOME: {
    label: GlobalLabels.TABS.INCOME.LABEL,
    icon: React.createElement(GlobalLabels.TABS.INCOME.ICON),
    button: {
      label: GlobalLabels.TABS.INCOME.BUTTON.LABEL,
      icon: React.createElement(GlobalLabels.TABS.INCOME.BUTTON.ICON),
    },
    description: GlobalLabels.TABS.INCOME.DESCRIPTION,
  },
  EXPENSES: {
    label: GlobalLabels.TABS.EXPENSES.LABEL,
    icon: React.createElement(GlobalLabels.TABS.EXPENSES.ICON),
    button: {
      label: GlobalLabels.TABS.EXPENSES.BUTTON.LABEL,
      icon: React.createElement(GlobalLabels.TABS.EXPENSES.BUTTON.ICON),
    },
    description: GlobalLabels.TABS.EXPENSES.DESCRIPTION,
  },
  DOCUMENTS: {
    label: GlobalLabels.TABS.DOCUMENTS.LABEL,
    icon: React.createElement(GlobalLabels.TABS.DOCUMENTS.ICON),
    button: {
      label: GlobalLabels.TABS.DOCUMENTS.BUTTON.LABEL,
      icon: React.createElement(GlobalLabels.TABS.DOCUMENTS.BUTTON.ICON),
    },
    description: GlobalLabels.TABS.DOCUMENTS.DESCRIPTION,
  },
  USERS: {
    label: GlobalLabels.TABS.USERS.LABEL,
    icon: React.createElement(GlobalLabels.TABS.USERS.ICON),
    button: {
      label: GlobalLabels.TABS.USERS.BUTTON.LABEL,
      icon: React.createElement(GlobalLabels.TABS.USERS.BUTTON.ICON),
    },
    description: GlobalLabels.TABS.USERS.DESCRIPTION,
  },
  CONTACTS: {
    label: GlobalLabels.TABS.CONTACTS.LABEL,
    icon: React.createElement(GlobalLabels.TABS.CONTACTS.ICON),
    button: {
      label: GlobalLabels.TABS.CONTACTS.BUTTON.LABEL,
      icon: React.createElement(GlobalLabels.TABS.CONTACTS.BUTTON.ICON),
    },
    description: GlobalLabels.TABS.CONTACTS.DESCRIPTION,
  },
  PROJECT_NOTES: {
    label: GlobalLabels.TABS.PROJECT_NOTES.LABEL,
    icon: React.createElement(GlobalLabels.TABS.PROJECT_NOTES.ICON),
    button: {
      label: GlobalLabels.TABS.PROJECT_NOTES.BUTTON.LABEL,
      icon: React.createElement(GlobalLabels.TABS.PROJECT_NOTES.BUTTON.ICON),
    },
    description: GlobalLabels.TABS.PROJECT_NOTES.DESCRIPTION,
  },
  ACTIVITY_LOG: {
    label: GlobalLabels.TABS.ACTIVITY_LOG.LABEL,
    icon: React.createElement(GlobalLabels.TABS.ACTIVITY_LOG.ICON),
    button: {
      label: GlobalLabels.TABS.ACTIVITY_LOG.BUTTON.LABEL,
      icon: React.createElement(GlobalLabels.TABS.ACTIVITY_LOG.BUTTON.ICON),
    },
    description: GlobalLabels.TABS.ACTIVITY_LOG.DESCRIPTION,
  },
};

export const AllocationCardEnum = {
  VEHICLE: {
    type: GlobalLabels.ALLOCATIONS.VEHICLE.TYPE,
    label: GlobalLabels.ALLOCATIONS.VEHICLE.LABEL,
    icon: React.createElement(GlobalLabels.ALLOCATIONS.VEHICLE.ICON),
    button: {
      label: GlobalLabels.ALLOCATIONS.VEHICLE.BUTTON.LABEL,
      icon: React.createElement(GlobalLabels.ALLOCATIONS.VEHICLE.BUTTON.ICON),
    },
  },
  RESOURCE: {
    type: GlobalLabels.ALLOCATIONS.RESOURCE.TYPE,
    label: GlobalLabels.ALLOCATIONS.RESOURCE.LABEL,
    icon: React.createElement(GlobalLabels.ALLOCATIONS.RESOURCE.ICON),
    button: {
      label: GlobalLabels.ALLOCATIONS.RESOURCE.BUTTON.LABEL,
      icon: React.createElement(GlobalLabels.ALLOCATIONS.RESOURCE.BUTTON.ICON),
    },
  },
  MASTER: {
    type: GlobalLabels.ALLOCATIONS.MASTER.TYPE,
    label: GlobalLabels.ALLOCATIONS.MASTER.LABEL,
    divisionLabel: GlobalLabels.ALLOCATIONS.MASTER.DIVISIONLABEL,
    icon: React.createElement(GlobalLabels.ALLOCATIONS.MASTER.ICON),
    button: {
      label: GlobalLabels.ALLOCATIONS.MASTER.BUTTON.LABEL,
      icon: React.createElement(GlobalLabels.ALLOCATIONS.MASTER.BUTTON.ICON),
    },
  },
  ROUTE: {
    type: GlobalLabels.ALLOCATIONS.ROUTE.TYPE,
    label: GlobalLabels.ALLOCATIONS.ROUTE.LABEL,
    icon: React.createElement(GlobalLabels.ALLOCATIONS.ROUTE.ICON),
    button: {
      label: GlobalLabels.ALLOCATIONS.ROUTE.BUTTON.LABEL,
      icon: React.createElement(GlobalLabels.ALLOCATIONS.ROUTE.BUTTON.ICON),
    },
  },
};
